import { createFileRoute } from '@tanstack/react-router'
import AuthGuard from '../components/AuthGuard'
import OnboardingFlow from '../components/onboarding/OnboardingFlow'
import { DashboardClient } from '../components/DashboardClient'
import { prefetchDevices, prefetchSchedules } from '../lib/route-prefetch'

export const Route = createFileRoute('/')({
  head: () => ({
    meta: [{ title: 'Dashboard | Unbreakable' }],
  }),
  beforeLoad: ({ context }) => {
    prefetchDevices(context.queryClient)
    prefetchSchedules(context.queryClient)
  },
  component: HomePage,
})

function HomePage() {
  return (
    <AuthGuard>
      <OnboardingFlow>
        <DashboardClient />
      </OnboardingFlow>
    </AuthGuard>
  )
}
